import { useAuth } from "@/context/AuthContext";
import { useMembershipUpgrade } from "@/components/TrialBanner";
import { Button } from "@/components/ui/button";
import { Lock, Loader2, Sparkles } from "lucide-react";

// Wraps member-only pages. Trial users see an upgrade prompt instead of the feature.
export default function MemberGate({ children }) {
  const { user } = useAuth();
  const { upgrade, busy } = useMembershipUpgrade();
  if (!user || user.role !== "trial") return children;
  return (
    <div className="max-w-lg mx-auto text-center py-16" data-testid="member-gate">
      <div className="h-16 w-16 rounded-full bg-gold/15 grid place-items-center mx-auto mb-5">
        <Lock className="h-7 w-7 text-gold" />
      </div>
      <h1 className="font-heading text-3xl font-bold">Members-only feature</h1>
      <p className="text-muted-foreground mt-3">
        This is available to full AR Club members. Activate your membership for a one-time ₦3,000 fee to unlock
        Art Holdings, wallets, auctions, referrals, withdrawals — and receive your ₦500 Welcome Cash-back.
      </p>
      <Button onClick={upgrade} disabled={busy} data-testid="gate-activate-btn" className="mt-6 h-12 px-8 rounded-full navy-gradient text-white font-semibold">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Sparkles className="h-4 w-4 mr-2" /> Activate Membership</>}
      </Button>
    </div>
  );
}
